//@ts-checks
import { createApp } from "vue";
//
import {$$Dic} from "../B2bTools";
import htmlNew from "./customEdit.html";
import b2bTypeahead from "./composant/b2bTypeahead";
import { toDate, may } from "./composant/b2bLangue";
import cardUsers from "./composant/cardUsers";

function nbe(object) {
	let nb = 0;
	for (let key in object) if (object[key]) nb++;
	return nb;
}
const jsNew = ({
	url: function (echangeur) {
		echangeur.addAction('b2b.linelist.edit', echangeur.hash, '', 'form');
		echangeur.addAction('b2b.linelistcustom.categoryList', echangeur.hash, '', 'categories');
		echangeur.addAction('groupe.list', {}, 'form', 'groupes');
		echangeur.addAction('b2b.codification.select', { classe: "orderdepartment" }, '', 'orderdepartment');
		//
	},
	onLoad: async function (echangeur) {
		let THIS = this;
		//
		const $$dic = new $$Dic(echangeur.form.$$dic);
		//
		const defaultsaisie = echangeur.form;
		if (!defaultsaisie.parent) defaultsaisie.parent = echangeur.hash.duplicate;
		//
		//	options.keys
		const app = createApp({
			components: {
				"type-ahead": b2bTypeahead				
			},
			data: function () {
				//
				function addPointPointPoint(array, item) {
					const a = array|| [];
					if (item && a.length!==1) a.unshift(item);
					return a;
				}
				//
				return {
					//
					reg1: defaultsaisie.regroupment.level1.v,
					reg2: defaultsaisie.regroupment.level2.v,
					//
					linelist: defaultsaisie,
					saisie: {
						brandnames: echangeur.form.brandnames || [],
						category: echangeur.form.category || '...',
						customtitle: echangeur.form.customtitle,
						customproducts: echangeur.form.customproducts,
						team: echangeur.form.team || "",
						orderdepartment: echangeur.form.orderdepartment|| "",
					},
					categoryList: addPointPointPoint(echangeur.categories.rows,"..." ),
					orderdepartmentOptions : addPointPointPoint(echangeur.orderdepartment.rows,{ k: "", v: "..." }),
					categorytxt: null,
					teamList: addPointPointPoint(echangeur.groupes.rows,{ k: "", v: "..." }),
					errors: {},
				}
			},
			computed: {

			},
			methods: {
				cancel: function () {
					THIS.fin();
				},
				categoryAdd() {
					this.categorytxt = this.categorytxt.trim();
					if (this.categorytxt && ! this.categoryList.includes(this.categorytxt)) {
						this.categoryList.push(this.categorytxt);
						this.saisie.category = this.categorytxt;
					}
					this.categorytxt = "";
				},
				may(key) {
					return may(key);
				},
				toDate: function (a) {
					return toDate(a);
				},
				toBrandname: function (k) {
					return  $$dic.brandname(k).v;
				},
				toBrandObject: function (k) {
					return $$dic.brandname(k);
				},
				toBuyer(k) {
					return $$dic.utilisateur(k);
                },
				pretenom(item) {
                    if(!may("PRETENOM")) return false;
                    const buyer = this.toBuyer(item)
                    if(buyer.profil=="dmk-buy") return true;
                    return false;
                },
                connectas(item) {
                    const url =  ""+ window.location;
                    const a = url.split("?")[0];
                    const b = a.split("#")[0];
                    const c = b+"?client=" + encodeURI(item)+"#";
                    window.location.assign( c );
                },
				fin: function () {
					THIS.fin();
				},
				toDate: function (date) {
					return toDate(date);
				},
				brandSelect(item) {
					// console.log(item)
					if (this.saisie.brandnames.indexOf(item._id) == -1) {
						this.saisie.brandnames.push(item._id);
						$$dic.addBrandname(item);
					}
				},
				brandRemove(_id) {
					this.saisie.brandnames = this.saisie.brandnames.filter(el => { return (el != _id) });
				},
				brandTypeahead() {
					return async function (key) {
						let v = await THIS.rest("b2b.brandname.typeahead", { k: key, limit: 10 })
						let retour = [];
						v.forEach(element => {
							retour.push({ _id: element._id, v: element.v, clients: element.clients, orderdepartments: element.orderdepartments, vth: element.v });
						});
						return retour;
					}
				},


				save: async function () {
					this.errors = {};
					let form = {
						_id: this.linelist._id,
						parent: this.linelist.parent,
						team: this.saisie.team,
						customtitle: this.saisie.customtitle,
						category: this.saisie.category,
						brandnames: this.saisie.brandnames,
						customproducts: this.saisie.customproducts,
						orderdepartment: this.saisie.orderdepartment,
					}
					
                   
                    
                    if (!form.orderdepartment ) this.errors.orderdepartment = true;
                   
                    if (!nbe(this.errors)) {
                        let data = await THIS.rest("b2b.linelistcustom.save", {}, form);
						if (data && data.ok) THIS.fin();
                    }
					

					
				},
			}
		});
		app.mount(THIS.c$('._vueChargement')[0]);
	},
	loader: function (echangeur) {

	},

});


export default {
	customEdit: { js: jsNew, html: htmlNew }
};
